import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const TONES = ["mint", "peach", "sky", "butter", "rose", "lilac"];

export const ModuleCard = ({ icon: Icon, title, text, brief, testid, delay = 0, tone }) => {
  const idx = Math.round(delay / 50);
  const t = tone || TONES[idx % TONES.length];
  return (
    <div
      className={cn("card-surface tone-wash fade-up group p-5 transition-transform duration-300 hover:-translate-y-1", `tone-${t}`)}
      style={{ animationDelay: `${delay}ms` }}
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="tone-chip flex h-11 w-11 items-center justify-center rounded-2xl transition-transform duration-300 group-hover:rotate-[-6deg] group-hover:scale-105">
          <Icon className="h-5 w-5" strokeWidth={1.9} />
        </div>
        <Badge variant="outline" className="rounded-full bg-card/70 text-[10px] font-semibold">Partie {brief}/8</Badge>
      </div>
      <h3 className="mt-4 text-base font-semibold">{title}</h3>
      <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{text}</p>
    </div>
  );
};
